<template>
	<div class="container">
		<div class="mainTop">
			<div class="mainLeft">
				<p>友情链接</p>
				<div>
					南京为老服务网 <span>|</span>
					沈阳为老服务网 <span>|</span>
					西宁为老服务网 <span>|</span>
					鞍山为老服务网 <span>|</span>
					泰州为老服务网 <span>|</span>
					绍兴为老服务网 <span>|</span>
					南京市高淳区为老服务网 <span>|</span>
					泰州市泰兴市为老服务网 <span>|</span>
					南昌市青山湖区为老服务网 <span>|</span>
					景德镇昌江区为老服务网
				</div>
			</div>
			<div class="mainLeft">
				<p>民政官网</p>
				<div>
					中华人民共和国民政部 <span>|</span>
					沈阳市民政局 <span>|</span>
					西宁民政局 <span>|</span>
					鞍山民政局 <span>|</span>
					泰州民政局 <span>|</span>
					绍兴民政局 <span>|</span>
					南京市高淳区民政局 <span>|</span>
					泰州市泰兴市民政局 <span>|</span>
					南昌市民政局 <span>|</span>
					景德镇市民政局
				</div>
			</div>
		</div>
		<div class="mainBottom">
			<p>
				<span>热线：（025）5836 2651</span>
				<span>邮箱：njyl12349@qq.com</span>
				<span>地址：南京市雨花台区宁双路28号汇智大厦A座215</span>
			</p>
			<div class="footer-title">
				<span>版权所有：颐倍康南京养老服务有限公司 版权所有 2016-2020 all rights reserved </span>
				<a href="https://beian.miit.gov.cn/" target="_blank">苏ICP备20048032号</a>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				
			}
		},
		methods:{
			handlejump(){
				this.$router.push("https://beian.miit.gov.cn/")
			}
		}
	}
</script>

<style scoped="scoped">
	.container{
	}
	.mainTop{
	background: #3F3F3F;
	padding: 26px 16%;
	display: flex;
	justify-content: space-between;
	}
	.mainLeft{
		width:47%;
	}
	.mainLeft>p{
		color:#E8E8E8;
		font-size: 19px;
	}
	.mainLeft>div{
		margin-top:20px;
		color:#E8E8E8;
		font-size:14px;
	}
	.mainLeft>div>span{
		display: inline-block;
		height:30px;
		line-height: 30px;
		padding: 0 4px;
	}
	.mainBottom{
		background:#333333;
		padding: 20px 16%;
	}
	.mainBottom>p{
		color:#E5E5E5;
		font-size:14px;
		text-align: center;
	}
	.mainBottom>p:first-of-type{
		margin-bottom: 10px;
	}
	.mainBottom>p:first-of-type>span:nth-of-type(2){
		margin:0 24px;
	}
	.footer-title{
		color:#E5E5E5;
		font-size:14px;
		display: flex;
		align-items: center;
		justify-content:center;
		
	}
	.footer-title a{
		color:#1085ff;
		font-size:14px;
		margin-left: 30px;
		text-decoration: none;
		cursor: pointer;
	}
	.footer-title a:hover{
		color:#180;
	}
	
</style>
